// Modules
import { captureConsoleIntegration, feedbackIntegration, init as initialize, replayIntegration, setUser } from '@sentry/react'

// Helpers
import { getTheme } from 'helpers/system'

// Constants
import { ENVIRONMENT, IS_LIVE, IS_ON_PREMISE } from 'constants/environment'

// Constants (Local)
const SENTRY_ENVIRONMENTS = Object.freeze({ development: 'dev', localhost: 'local', production: 'prod', test: 'test' })
const SENTRY_DATA_SOURCE = 'https://77f179a4d592bb15c8efaa7b546b7154@o4507906801205248.ingest.us.sentry.io/4507923102433280'

// Data (Local)
const feedbackConfiguration = {
	autoInject: false,
	colorScheme: getTheme(), // TODO: This sets the theme only once. Changing the theme does not affect the widget.
	showBranding: false,
	showEmail: true,
	showName: false,
	onFormClose: !!window.feedbackPanel ? () => window.feedbackPanel.removeFromDom() : null
}
const feedback = feedbackIntegration(feedbackConfiguration)
const replay = replayIntegration() // WARNING: Text masking, input masking and media blocking are on by default, do not disable them on this application

// Helper: Sentry > Set Sentry user
function setSentryUser ({ email, id, username }) {
	if (IS_ON_PREMISE) return
	setUser({ email, id, username })
}

// Helper: Sentry > Initialize Sentry
function initializeSentry () {
	if (IS_ON_PREMISE) return
	initialize({
		dsn: SENTRY_DATA_SOURCE,
		environment: SENTRY_ENVIRONMENTS[ENVIRONMENT],
		integrations: [
			...(IS_LIVE ? [captureConsoleIntegration('error')] : []),
			feedback,
			replay
		],
		profilesSampleRate: 0.05,
		replaysOnErrorSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		tracesSampleRate: 0.05
	})
}

// Helper: Sentry > Open Sentry panel
async function openSentryPanel ({ cancelButtonText, data, descriptionPlaceholder, confirmButtonText, title } = {}) {
	if (IS_ON_PREMISE) return
	window.feedbackPanel = await feedback.createForm({
		cancelButtonLabel: cancelButtonText || 'Cancel',
		formTitle: title || 'Help us improve aixplain!',
		messagePlaceholder: descriptionPlaceholder || 'Explain your feedback in detail',
		submitButtonLabel: confirmButtonText || 'Send',
		tags: {
			...data,
			path: window.location.pathname
		}
	})
	window.feedbackPanel.appendToDom()
	window.feedbackPanel.open()
}

// Export
export {
	initializeSentry,
	openSentryPanel,
	setSentryUser
}
